import emptyConfig from '@apis/appConfigs/initConfig.json';
import api from '@apis/api';

const useFeatureSettings = () => {
    const { data: configs = emptyConfig, error, isLoading } = api.useGetPublicConfigsQuery();
    const { featureSettings } = configs;
    return featureSettings;
};

export default useFeatureSettings;
